import ColumnVideo from './src/live-columnvideo.vue'
import { useStorage } from '@/hooks/web/useStorage'
import useApi from '@/api/live'
import { isEmpty } from '@/utils/is'

export { ColumnVideo }
const { getStorage, setStorage } = useStorage()
/**
 * 栏目播放记录本地存取
 * type: get-获取、set-设置
 * id: 视频id
 * time: 播放时间
 * */
export const ColumnVideoStorage = (type: string, id = 0, time = 0) => {
  const list = getStorage('columnVideoPlay') || []
  const index = list.findIndex((item: any) => item.includes(id))
  if (type === 'get') {
    const info = index === -1 ? 0 : list[index].split('_')[1]
    return info
  }
  if (index !== -1) {
    list.splice(index, 1, `${id}_${time}`)
  } else {
    list.push(`${id}_${time}`)
  }
  setStorage('columnVideoPlay', list)
}

/** 获取栏目config */
export const getColumnConfig = async () => {
  const params = {
    columnId: getStorage('columnId') || '',
    clientId: getStorage('clientId') || ''
  }
  try {
    const columnRes: any = await useApi.getColumnConfig(params)
    const { code = 0, data = {} } = columnRes
    if (code === 200 && !isEmpty(data)) {
      window.location.href = data?.columnUrl
      return
    } else if (res.code === 1006) {
      window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/6`
    } else if (code === 1009) {
      window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/11`
    } else if (code === 1010) {
      window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/10`
    }
    window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/9`
  } catch (error) {
    window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/9`
  }
}

/** 判断栏目回放视频是否需要重置 */
export const resetColumnVideo = (plist = [], nlist = [], time = 0) => {
  const list = plist.filter((v: any) => v.seconds <= time)?.sort((a: any, b: any) => a.seconds - b.seconds) || []
  const info: any = list[list.length - 1] || {}
  const newInfo: any = nlist[nlist.length - 1] || {}
  if (info?.mainShow === newInfo?.mainShow && info?.mixShow === newInfo?.mixShow) {
    return false
  } else {
    return list[list.length - 1]
  }
}
